import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import networks_gen_2_plus_sleeping from '@devices/settings/device_settings/networks_gen_2_plus_sleeping.js';
import app from '@devices/settings/device_settings/app.js';
import share from '@devices/settings/device_settings/share.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';
import motion_settings_presence_g4 from '@devices/settings/device_settings/motion_settings_presence_g4.js';

export default {
	name: 'ShellyPresenceCG4',
	friendly_name: 'Presence C Gen4',
	family: 'sensor',
	isRadar: false,
	isPM: false,
	modes: {
		sensor: {
			channels: 1,
			notifications: ['offline', 'device_problem'],
			settings: [
				schedule_gen_2,
				webhooks_gen_2,
				networks_gen_2_plus_sleeping,
				bluetooth_gen_2,
				app,
				share,
				motion_settings_presence_g4,
				{
					title: 'settings',
					components: [
						{ title: 'device_name', component: 'device_name' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'location_g2',
						},
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
